<template>
  <div>
    <template v-if="$store.state.userProfile">
      <b-form-group class="mb-3">
        <b-form-textarea
          v-model="commentBody"
          placeholder="Enter your comment"
          rows="8"
        ></b-form-textarea>
        <template #description>
          Uses
          <b-link
            href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet"
            target="_blank"
            >Github-flavoured markdown</b-link
          >
          : <em>*italic*</em>, <strong>**bold**</strong>, [link
          text](https://linkdestination.com/whatever)
        </template>
      </b-form-group>
      <b-card v-if="this.commentBody.trim()" header="Preview" class="mb-3">
        <div v-html="parseMarkdown(commentBody)"></div>
      </b-card>
      <div class="text-right mt-3">
        <b-button
          @click="$emit('submit:comment', commentBody)"
          :disabled="!this.commentBody.trim()"
          >Comment</b-button
        >
      </div>
    </template>
    <em v-else>Please log in to comment.</em>
  </div>
</template>

<script>
import markdown from "@/mixins/markdown";

export default {
  name: "CommentEditor",
  mixins: [markdown],
  data() {
    return {};
  },
  computed: {
    commentBody: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>
